import { SeverityLevel, } from "@microsoft/applicationinsights-web";
import { getLegacyUserId, getLoginName, getUserId } from "./TokenHelper";
export var GetFullLoggingInfoForLoggedInUser = function (message) {
    var _a, _b, _c;
    var userId = (_a = getUserId()) !== null && _a !== void 0 ? _a : "undefined";
    var legacyUserId = (_b = getLegacyUserId()) !== null && _b !== void 0 ? _b : "undefined";
    var loginName = (_c = getLoginName()) !== null && _c !== void 0 ? _c : "undefined";
    var loggedInPackage = {
        message: message,
        userId: userId,
        legacyUserId: legacyUserId,
        loginName: loginName,
    };
    var serializedPackage = JSON.stringify(loggedInPackage);
    return serializedPackage;
};
export var GetLoggingErrorFromHandledException = function (exception) {
    var error = new Error(exception.message);
    error.name = "HandledRequestException";
    return error;
};
export var GetLoggingErrorFromUnhandledException = function (exception, message) {
    var error = new Error(message + exception.message);
    error.name = "UnhandledRequestException";
    return error;
};
export var LogException = function (appInsights, error) {
    try {
        if (appInsights) {
            appInsights.trackException({
                exception: error,
                severityLevel: SeverityLevel.Error,
            });
        }
        else {
            console.error("appInsights is not accessible");
        }
    }
    catch (error) {
        console.error("Error logging to Application Insights:", error);
    }
};
